var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col-md-6 form" }, [
      _c("div", { staticClass: "body" }, [_vm._t("body")], 2),
      _vm._v(" "),
      _vm.showFooter
        ? _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "text" }, [_vm._t("footer-text")], 2),
            _vm._v(" "),
            _c("div", { staticClass: "actions" }, [_vm._t("footer-actions")], 2)
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.showSecured
      ? _c("div", { staticClass: "secure" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("img", {
            attrs: { src: require("@/assets/images/logo/omise.png") }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "fas fa-lock" }),
      _vm._v("\n      Secured by\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35b53f8b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b53f8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BasePaymentForm.vue
// module id = null
// module chunks = 